import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/toaster';
import Layout from './components/Layout';
import SplashScreen from './components/SplashScreen';
import Home from './pages/Home';
import MyStory from './pages/MyStory';
import Experience from './pages/Experience';
import BookDrGee from './pages/BookDrGee';
import Fireside from './pages/Fireside';
import Shop from './pages/Shop';
import FAQs from './pages/FAQs';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Events from './pages/Events';
import Admin from './pages/Admin';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <SplashScreen />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="my-story" element={<MyStory />} />
              <Route path="experience" element={<Experience />} />
              <Route path="book" element={<BookDrGee />} />
              <Route path="fireside" element={<Fireside />} />
              <Route path="shop" element={<Shop />} />
              <Route path="faqs" element={<FAQs />} />
              <Route path="contact" element={<Contact />} />
              <Route path="terms" element={<Terms />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="events" element={<Events />} />
              <Route path="payment/success" element={<PaymentSuccess />} />
              <Route path="payment/cancel" element={<PaymentCancel />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
